import React from 'react';
import './SplashScreen.css';

const SplashScreen = () => {
  return (
    <div className="splash-screen">
      <div className="splash-particles">
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
      </div>
      <div className="splash-content">
        <div className="logo-container-splash">
          <img 
            src="/logo-cantinho.png" 
            alt="Cantinho do Sabor"
            className="logo-splash"
          />
        </div>
        <div className="loading-container">
          <div className="loading-spinner">
            <div className="spinner-ring"></div>
          </div>
          <p className="splash-text">Carregando...</p>
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;
